import { useAuth0 } from 'app/Auth'
import { downloadWalletPass } from 'lib/services/api/wallet-service'
import { WalletCardDownloadProps, WalletType } from './WalletCardDownload.types'

export const useWalletCardDownload = ({
  patientId,
  surgeryId,
}: WalletCardDownloadProps) => {
  const { getAccessToken } = useAuth0()
  const WALLET_API_URL = process.env.REACT_APP_WALLET_API_URL?.replace(
    /\/$/,
    ''
  )

  const handleWalletDownload = async (walletType: WalletType) => {
    try {
      const url = await downloadWalletPass(
        patientId,
        surgeryId,
        walletType,
        getAccessToken
      )
      window.open(url, '_blank')
    } catch (error) {
      console.error('Error getting wallet pass URL', error)
    }
  }

  const handleAppleWalletDownload = async () => {
    try {
      const downloadUrl = `${WALLET_API_URL}/surgery_passes/${patientId}/${surgeryId}/apple`

      // Open the download URL in a new tab
      window.open(downloadUrl, '_blank')
    } catch (error) {
      console.error('Error opening Apple wallet pass download', error)
    }
  }

  return {
    handleWalletDownload,
    handleAppleWalletDownload,
  }
}
